import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    company: [
      { label: 'About Us', path: '/homepage' },
      { label: 'Success Stories', path: '/success-stories' },
      { label: 'Partnership Network', path: '/partnership-network' },
      { label: 'Contact', path: '/contact' }
    ],
    services: [
      { label: 'Player Representation', path: '/services-overview' },
      { label: 'Transfer Services', path: '/services-overview' },
      { label: 'Career Development', path: '/services-overview' },
      { label: 'Market Intelligence', path: '/market-intelligence' }
    ],
    resources: [
      { label: 'Player Profiles', path: '/player-profiles' },
      { label: 'Compliance Center', path: '/compliance-center' },
      { label: 'Client Portal', path: '/client-portal' },
      { label: 'Market Reports', path: '/market-intelligence' }
    ]
  };

  const socialLinks = [
    { icon: 'Linkedin', url: '#', label: 'LinkedIn' },
    { icon: 'Twitter', url: '#', label: 'Twitter' },
    { icon: 'Facebook', url: '#', label: 'Facebook' },
    { icon: 'Instagram', url: '#', label: 'Instagram' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10 lg:gap-12 mb-10 md:mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Trophy" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-xl font-bold text-primary font-headline">ProX11Market</span>
            </div>
            <p className="text-sm md:text-base text-muted-foreground mb-6 leading-relaxed">
              Bridging African football excellence with European opportunities through FIFA-compliant processes, advanced analytics, and comprehensive career management.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  aria-label={social?.label}
                  className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300"
                >
                  <Icon name={social?.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold text-foreground mb-4 font-headline">Company</h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => navigate(link?.path)}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold text-foreground mb-4 font-headline">Services</h3>
            <ul className="space-y-3">
              {footerLinks?.services?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => navigate(link?.path)}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold text-foreground mb-4 font-headline">Resources</h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => navigate(link?.path)}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs md:text-sm text-muted-foreground text-center md:text-left">
              &copy; {currentYear} ProX11Market. All rights reserved. FIFA Compliant Operations.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <button className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                Privacy Policy
              </button>
              <button className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                Terms of Service
              </button>
              <button className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                Cookie Policy
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;